import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/ComboBox/sgds-combo-box";
import { register } from "../../utils/ce-registry";

register("sgds-combo-box", Component);

export default createComponent({
  react: React,
  tagName: "sgds-combo-box",
  elementClass: Component,
  events: {
    onSgdsSelect: "sgds-select",
    onSgdsChange: "sgds-change",
    onSgdsInput: "sgds-input",
    onSgdsFocus: "sgds-focus",
    onSgdsBlur: "sgds-blur",
    onSgdsInvalid: "sgds-invalid",
    onSgdsValid: "sgds-valid",
    onSgdsShow: "sgds-show",
    onSgdsAfterShow: "sgds-after-show",
    onSgdsHide: "sgds-hide",
    onSgdsAfterHide: "sgds-after-hide"
  }
});
